module.exports = __webpack_public_path__ + "static/typewriter-4a54dbc9262db3e5dd8fe33fe8277f36.png";